import gsap from 'gsap';

export default function iotHeroBanner() {
  const block = document.querySelector('.iotHeroBanner');
  const isReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!block || isReduceMotion) {
    return;
  }

  const tl = gsap.timeline({
    repeat: -1,
    repeatDelay: 1.5,
    delay: 0.5,
    yoyo: true,
    ease: 'power2.inOut'
  });

  tl.from('#dot_1', { duration: 0.6, y: '+=40%', autoAlpha: 0 })
    .from('#dot_5', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.3')
    .from('#dot_2', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.7')
    .from('#dot_8', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.4')
    .from('#dot_7', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.4')
    .from('#dot_3', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.4')
    .from('#dot_4', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.3')
    .from('#dot_6', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.4')
    .from('#dot_9', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.6')
    .from('#dot_10', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.4')
    .from('#dot_11', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.4')
    .from('#dot_12', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.3')
    .from('#dot_13', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.05')
    .from('#dot_14', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.3')
    .from('#dot_15', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.1')
    .from('#dot_16', { duration: 0.6, y: '+=40%', autoAlpha: 0 }, '>-0.2')
}
